export const PUBLIC_PAGE = {
  CONTACT_TO_AGENT: 'Contact to Agent',
  ENTER_PUBLIC_PROFILE: 'Enter to public profile',
  CLICK_SOCIAL_BUTTON: 'click %socialType% button',
  CLICK_PRIMARY_WEBSITE_LINK: 'click link primary',
  CLICK_SECONDARY_WEBSITE_LINK: 'click link secondary',
  CLICK_SEND_MESSAGE: 'click send a message',
  CLICK_SIGN_UP: 'click sign up',
  CLICK_GO_TO_MESSAGE: 'click go to messages',
  CLICK_VIEW_LISTING_PAGE: 'click view listing page',
  CLICK_CALL_TO_AGENT: 'click call to agent',
}

export const LISTING_PUBLIC_PAGE = {
  CLICK_APPLY_ON_PUBLIC_LISTING_PAGE: 'Click Apply on public listing page',
  CLICK_MANAGE_YOUR_LISTING: 'Click manage your listing',
  CLICK_CONTACT_AGENT: 'click contact agent',
  CLICK_CONTINUE_ON_CONTACT_MODAL: 'click continue on contact modal',
  VIEW_AGENT_PROFILE_ON_PUBLIC_LISTING_PAGE: 'View agent profile on public listing page',
  VIEW_IMAGE_IN_LIGHTBOX: 'View image in lightbox',
  REPORT_LISTING: 'Report listing',
  CLICK_ON_MAP: 'click on google map',
  CLICK_STREET_VIEW: 'click street view',
  CLICK_WATCH_VIDEO_TOUR: 'Click watch video tour',
  WATCH_FULL_VIDEO_TOUR: 'Watch full video tour',
  VIEW_LISTING: 'view public listing page',
  CLICK_NEARBY_PLACE: 'click nearby place',
  SHARE_LISTING_PAGE: 'share listing page',
  SUBMIT_PRE_SCREEN: 'submit pre screen',
  CLICK_CONTINUE_TOUR_MODAL: 'click continue on schedule tour modal',
  SUBMIT_TOUR_REQUEST: 'submit tour request',
  CLICK_REQUEST_TOUR: 'click request a tour',
  CLICK_VIEW_MAP_ON_FULLSCREEN: 'click view map in fullscreen',
}

export const NAVBAR = {
  LEAVE_PAGE_VIA_NAVBAR: 'leave page via nav bar',
}

export const MAIN_FEATURE = {
  MARKET_LISTING: 'market_listing',
}

export const LOCATION = {
  PREVIEW_LISTING: 'preview_listing',
  PUBLIC_LISTING: 'public_listing',
  REVIEW_LISTING: 'review_listing',
  CONTACT_HOST_MODAL: 'contact_host_modal',
  REQUEST_TOUR_MODAL: 'request_a_tour_modal',
  SHARE_SUCCESS: 'share_success',
}
